import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Play, ExternalLink } from 'lucide-react';

const FeaturedVideo = () => {
  const handleVideoClick = () => {
    window.open('https://www.ted.com/talks/dan_casey_the_retirement_remedy_the_plan_to_make_your_nest_egg_last?utm_campaign=tedspread&utm_medium=referral&utm_source=tedcomshare', '_blank');
  };

  return (
    <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Badge className="mb-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 text-lg font-semibold">
            FEATURED TEDx TALK
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            The Retirement Remedy
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Discover the proven plan to make your nest egg last and reduce taxation in retirement
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <Card className="overflow-hidden shadow-2xl border-0 bg-white">
            <CardContent className="p-0">
              <div className="relative">
                <div className="aspect-video cursor-pointer group" onClick={handleVideoClick}>
                  <img 
                    src="https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750646862517_b8f584cc.png" 
                    alt="Dan Casey TEDx Talk - The Retirement Remedy" 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center group-hover:bg-opacity-40 transition-all">
                    <div className="w-24 h-24 bg-red-600 rounded-full flex items-center justify-center group-hover:bg-red-700 transition-colors shadow-lg">
                      <Play className="w-10 h-10 text-white ml-1" fill="white" />
                    </div>
                  </div>
                </div>
                <div className="absolute top-4 right-4">
                  <Badge className="bg-red-600 text-white px-3 py-1">
                    TEDx Talk
                  </Badge>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  How to Reduce Taxation in Retirement
                </h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Join Dan Casey as he reveals the retirement remedy that can help you keep more of your hard-earned money. This comprehensive plan shows you exactly how to structure your retirement savings to minimize taxes and maximize your nest egg's longevity.
                </p>
                
                <Button 
                  onClick={handleVideoClick}
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 text-lg font-semibold"
                >
                  <ExternalLink className="w-5 h-5 mr-2" />
                  Watch Full Talk
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default FeaturedVideo;